export const onboarding = {
  // driver.js popover buttons
  controls: {
    next: 'Next',
    back: 'Back',
    done: 'Done',
    skip: 'Skip',
  },
  // Sidebar "Help & tips" menu
  help: {
    menuLabel: 'Help & tips',
    restartWelcome: 'Restart the welcome tour',
    takeTour: {
      welcome: 'Tour: the basics',
      review: 'Tour: reviewing a document',
      playbooks: 'Tour: playbooks',
    },
  },
  tours: {
    welcome: {
      newChat: {
        title: 'Start a conversation',
        body: 'Begin a fresh chat with QAgent — ask a question, paste text, or drop in a document to review.',
      },
      newContract: {
        title: 'Draft from scratch',
        body: 'Generate a first draft of a contract or legal document, guided step by step.',
      },
      projects: {
        title: 'Organize your work',
        body: 'Group documents, playbooks and chats into projects so everything for a matter lives in one place.',
      },
      playbooks: {
        title: 'Your playbooks',
        body: 'Playbooks are reusable sets of review rules. Apply one and QAgent checks a document against your standards.',
      },
      messageBox: {
        title: 'Ask anything',
        body: 'Type here to chat with QAgent — review a clause, ask about obligations, or request changes.',
      },
      prompts: {
        title: 'Quick starts',
        body: 'Not sure where to begin? Pick one of these to kick things off.',
      },
      dropZone: {
        title: 'Drop a document',
        body: 'Drag a Word, PDF or text file anywhere here to attach it and start a review.',
      },
      installWord: {
        title: 'Use it in Word',
        body: 'Prefer working in Microsoft Word? Install the Queri add-in to review and redline right inside your document.',
      },
      userMenu: {
        title: 'Settings & language',
        body: 'Switch between English and Swedish, replay these tours, or sign out from here.',
      },
      finish: {
        title: "You're all set",
        body: 'That’s the tour! You can replay it anytime from “Help & tips” in the menu below.',
      },
    },
    review: {
      mention: {
        title: 'Reference files & playbooks',
        body: 'Type “@” in the message box to point QAgent at a specific file or playbook in this project.',
      },
      resources: {
        title: 'Project resources',
        body: 'Open this panel to see the files and playbooks QAgent is using, and to upload more.',
      },
      suggestion: {
        title: 'Review suggestions',
        body: 'QAgent proposes edits as suggestions. Accept the ones you want, reject the rest — nothing changes until you decide.',
      },
      export: {
        title: 'Export with your changes',
        body: 'When you’re happy, download the document with the accepted changes applied.',
      },
    },
    playbooks: {
      intro: {
        title: 'Playbooks',
        body: 'A playbook is a reusable set of rules QAgent uses to review a document against your standards.',
      },
      create: {
        title: 'Create a playbook',
        body: 'Build one from scratch: give it a name and agreement type, then add rules — each rule is an instruction QAgent follows when reviewing.',
      },
      import: {
        title: 'Import a checklist',
        body: 'Already have your standards in a document or spreadsheet? Import it and QAgent turns it into a playbook of rules.',
      },
      ai: {
        title: '…or let AI draft one',
        body: 'Have a sample contract? Let QAgent read it and generate a starter playbook you can refine.',
      },
      apply: {
        title: 'Put a playbook to work',
        body: 'To review a document against a playbook, open a chat and type “@” to reference it — QAgent checks the document rule by rule and suggests edits.',
      },
    },
  },
  tips: {
    dropDocument: {
      title: 'Tip',
      body: 'Drag a document anywhere on this screen to start a review.',
    },
    mention: {
      title: 'Tip',
      body: 'Type “@” to reference a specific file or playbook.',
    },
    dismiss: 'Got it',
  },
};

export type OnboardingDict = typeof onboarding;
